import React, { ReactElement } from 'react';
import Container from '@material-ui/core/Container';

interface LayoutProps {
    children: ReactElement | ReactElement[];
}
export const Layout = (props: LayoutProps) => {
    return (
        <Container maxWidth='sm'>
            {props.children}
        </Container>
    );
};
